/* eslint-disable no-unused-expressions */
/* eslint-disable no-restricted-globals */
import React, { useState, Fragment, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Select, Button, Collapse, Table, notification,
} from 'antd';
import PropTypes from 'prop-types';
import H3Text from '@Uilib/h3Text';
import ForecastActions from '@Actions/application/forecastActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCaretRight, faCircleCheck, faDownload, faChartArea, faWarning, faInfoCircle, faAngleRight, faAngleDown,
} from '@fortawesome/free-solid-svg-icons';
import ReactApexChart from 'react-apexcharts';
import dayjs from 'dayjs';
import ForecastAnalysis from '@Components/Forecasting/ForecastForm/ForecastAnalysis';
import './style.scss';
import { DownloadOutlined } from '@ant-design/icons';
import PRZSelect from '../../../Common/UI/PRZSelect';

const { Panel } = Collapse;
const { Option } = Select;

/**
 *
 */
function ForecastResults({
  user, forecastResults, getForecastById,
  selectedForecast, getForecastResults, getForecastResultsLoading, MONEY, match,
  downloadForecast, downloadForecastLoading,
}) {
  const [isUserReady, setIsUserReady] = useState(false);
  const [activeChange, setActiveChange] = useState(false);
  const [selectedModel, setSelectedModel] = useState('xgboost');
  const [selectedStore, setSelectedStore] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState([]);
  const [selectedChannel, setSelectedChannel] = useState([]);
  const [infoKey, setInfoKey] = useState('1');
  const [salesKey, setSalesKey] = useState('');
  const [groupBy, setGroupBy] = useState('ITEM');
  const [selectedGroup, setSelectedGroup] = useState('ITEM');

  const getForecastedChartData = (key) => {
    let results = [];
    if (key === 'TOTAL') {
      results = forecastResults?.total_forecast_day_on_day?.map((item) => ({
        x: dayjs(item?.date)?.valueOf(),
        y: Number(Number(item?.predicted_sales)?.toFixed(0)) || Number(Number(item?.predicted_quantity)?.toFixed(0)),
      }));
    }
    return results;
  };

  const seriesLine = [{
    name: 'Sales',
    data: getForecastedChartData('TOTAL'),
  }];
  const optionsLine = {
    chart: {
      id: 'chart',
      type: 'line',
    },
    dataLabels: {
      enabled: false,
    },
    colors: ['rgba(50,180,13,0.7)'],
    fill: {
      type: 'gradient',
      gradient: {
        shade: 'light',
        gradientToColors: ['rgba(0,143,251,0.1)', 'rgba(0,143,251,0.6)'],
        shadeIntensity: 4,
        type: 'vertical',
        opacityFrom: 1,
        opacityTo: 1,
      },
    },
    xaxis: {
      type: 'datetime',
      tooltip: {
        enabled: false,
      },
    },
    stroke: {
      width: 3,
      curve: 'smooth',
      colors: ['rgb(79,148,255)'],
      type: 'gradient',
      gradient: {
        shade: 'light',
        gradientToColors: ['rgba(0,143,251,0.1)', 'rgba(0,143,251,0.6)'],
        shadeIntensity: 4,
        type: 'vertical',
        opacityFrom: 1,
        opacityTo: 1,
      },
    },
    yaxis: {
      tickAmount: 8,
      tooltip: {
        enabled: false,
      },
      labels: {
        formatter(value) {
          return selectedForecast?.target === 'quantity' ? `${value} Nos` : MONEY(value);
        },
      },
    },
  };

  useEffect(() => {
    if (!isUserReady) {
      getForecastResults({
        forecastId: selectedForecast?.forecast_id,
        modelName: selectedModel,
        store: selectedStore?.join(','),
        item: selectedProduct?.join(','),
      });
      setIsUserReady(true);
    }
  }, [isUserReady]);

  /**
   *
   * @returns {null}
   */
  const getBestModel = () => {
    let lowestPair = null;
    if (selectedForecast?.model_percentage_errors) {
      for (const key in selectedForecast?.model_percentage_errors) {
        if (lowestPair === null || selectedForecast?.model_percentage_errors[key] < lowestPair?.value) {
          lowestPair = { key, value: selectedForecast?.model_percentage_errors[key] };
        }
      }
    }
    return lowestPair;
  };

  const Recommended = () => (
    <div style={{
      display: 'flex',
      fontSize: '10px',
      alignItems: 'center',
      color: '#1AC05D',
      fontWeight: 500,
    }}
    >
      <div style={{
        width: '10px',
        height: '10px',
        borderRadius: '50%',
        backgroundColor: '#1AC05D',
        marginRight: '2px',
      }}
      />
      {' '}
      Recommended
    </div>
  );

  const getExplodedViewColumns = () => {
    const columns = [];
    const totalDates = forecastResults?.total_forecast_day_on_day;
    columns.push({
      title: '',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      fixed: 'left',
      render: (record) => <div style={{ maxWidth: '150px' }}>{record?.sales}</div>,
    });
    for (let i = 0; i < totalDates?.length; i++) {
      columns.push({
        title: dayjs(totalDates?.[i]?.date).format('DD MMM'),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (record) => (selectedForecast?.target === 'quantity' ? `${record[dayjs(totalDates?.[i]?.date).format('DD MMM')]} Nos` : MONEY(record[dayjs(totalDates?.[i]?.date).format('DD MMM')])),
      });
    }
    return columns;
  };
  const getExplodedViewData = () => {
    const totalDates = forecastResults?.total_forecast_day_on_day;
    const additionalData = [];
    let data = {
      sales: 'Daily Forecast',
    };
    for (let i = 0; i < totalDates?.length; i++) {
      data = {
        ...data,
        [dayjs(totalDates?.[i]?.date).format('DD MMM')]: Number(totalDates?.[i]?.predicted_sales?.toFixed(2)) || Number(totalDates?.[i]?.predicted_quantity?.toFixed(2)),
      };
    }
    if (selectedGroup === 'STORE') {
      const totalStores = forecastResults?.store_forecast_day_on_day;
      for (let i = 0; i < totalStores?.length; i++) {
        let storeData = {
          sales: totalStores[i]?.store,
        };
        for (let j = 0; j < totalStores[i]?.day_on_day_forecasts?.length; j++) {
          storeData = {
            ...storeData,
            [dayjs(totalStores[i]?.day_on_day_forecasts?.[j]?.date).format('DD MMM')]: Number(totalStores[i]?.day_on_day_forecasts?.[j]?.predicted_sales?.toFixed(2)) || Number(totalStores[i]?.day_on_day_forecasts?.[j]?.predicted_quantity?.toFixed(2)),
          };
        }
        additionalData.push(storeData);
      }
    }
    if (selectedGroup === 'ITEM') {
      const totalItems = forecastResults?.item_forecast_day_on_day;
      for (let i = 0; i < totalItems?.length; i++) {
        let storeData = {
          sales: totalItems[i]?.item,
        };
        for (let j = 0; j < totalItems[i]?.day_on_day_forecasts?.length; j++) {
          storeData = {
            ...storeData,
            [dayjs(totalItems[i]?.day_on_day_forecasts?.[j]?.date).format('DD MMM')]: Number(totalItems[i]?.day_on_day_forecasts?.[j]?.predicted_sales?.toFixed(2)) || Number(totalItems[i]?.day_on_day_forecasts?.[j]?.predicted_quantity?.toFixed(2)),
          };
        }
        additionalData.push(storeData);
      }
    }
    return [data, ...additionalData];
  };

  /**
   *
   */
  return (
    <Fragment>
      <div className={`forecast-result__wrapper ${match?.params?.forecastId ? 'forecast-result__wrapper-borderless' : ''}`}>
        <H3Text
          text={(
            <div className="flex-display">
              <H3Text text={`#${selectedForecast?.forecast_number} ${selectedForecast?.forecast_name}`} className="forecast-result__title-text" />
            </div>
          )}
          className="forecast-result__title"
        />
        <div style={{ width: 'calc(100% - 5px)' }}>
          <div className="document-e-way-info">
            <Collapse
              bordered={false}
              defaultActiveKey={[infoKey]}
              onChange={(key) => {
                setInfoKey(key);
              }}
            >
              <Panel
                header={(
                  <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                    <div>
                      <FontAwesomeIcon icon={faChartArea} />
                      <span style={{ marginLeft: '5px' }}>Forecast Details</span>
                      <FontAwesomeIcon icon={infoKey == '1' ? faAngleDown : faAngleRight} style={{ marginTop: '1px', marginLeft: '5px', transition: '0.2s' }} />
                    </div>
                    <div style={{ marginLeft: 'auto' }}>
                      {selectedForecast?.status === 'TRAINED' && (
                        <div className="forecast-result__title-status">
                          <FontAwesomeIcon icon={faCircleCheck} />
                                &nbsp;Your forecast is Ready
                        </div>
                      )}
                      {selectedForecast?.status === 'TRAINING_FAILED' && (
                        <div className="forecast-form__processed-header__title-status">
                          <FontAwesomeIcon icon={faWarning} style={{ color: 'red' }} />
                                &nbsp;Data Forecasting Failed
                        </div>
                      )}
                    </div>
                  </div>
                )}
                key="1"
              >
                <div className="forecast-result__header">
                  <div className="ant-row">
                    <div className="ant-col-md-16">
                      <div className="forecast-result__models">
                        <H3Text text="Procuzy uses multiple AI Models to forecast your data. We have selected the model with highest accuracy accuracy based on your validation data" className="forecast-result__models-title" />
                        <div className="forecast-result__models-wrapper">
                          <div className={`forecast-result__models-info ${getBestModel()?.key === 'xgb_model' ? 'forecast-result__models-info-recommended' : ''}`}>
                            <H3Text text={`${Number((100 - selectedForecast?.model_percentage_errors?.xgb_model)?.toFixed(2))}%`} className="forecast-result__models-info__number" />
                            <H3Text text="XGBoost Model" className="forecast-result__models-info__label" />
                          </div>
                          <div className={`forecast-result__models-info ${getBestModel()?.key === 'lasso_model' ? 'forecast-result__models-info-recommended' : ''}`}>
                            <H3Text text={`${Number((100 - selectedForecast?.model_percentage_errors?.lasso_model)?.toFixed(2))}%`} className="forecast-result__models-info__number" />
                            <H3Text text="Lasso Model" className="forecast-result__models-info__label" />
                          </div>
                          <div className={`forecast-result__models-info ${getBestModel()?.key === 'ridge_model' ? 'forecast-result__models-info-recommended' : ''}`}>
                            <H3Text text={`${Number((100 - selectedForecast?.model_percentage_errors?.ridge_model)?.toFixed(2))}%`} className="forecast-result__models-info__number" />
                            <H3Text text="Ridge Model" className="forecast-result__models-info__label" />
                          </div>
                          <div className={`forecast-result__models-info ${getBestModel()?.key === 'lr_model' ? 'forecast-result__models-info-recommended' : ''}`}>
                            <H3Text text={`${Number((100 - selectedForecast?.model_percentage_errors?.lr_model)?.toFixed(2))}%`} className="forecast-result__models-info__number" />
                            <H3Text text="Linear Regression" className="forecast-result__models-info__label" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ant-col-md-8">
                      <div className="forecast-result__info">
                        <div className="forecast-result__info-row">
                          <H3Text text="Input Sales Data" className="forecast-result__info-row-label" />

                          <H3Text
                            text={(
                              <a href={selectedForecast?.data_source_ref_url} target="_blank" rel="noreferrer">
                                {selectedForecast?.data_source_ref?.split('_')?.[2]?.length > 20 ? `${selectedForecast?.data_source_ref?.split('_')?.[2]?.substring(0, 20)}..` : selectedForecast?.data_source_ref?.split('_')?.[2]}
                                    &nbsp;
                                <FontAwesomeIcon icon={faDownload} />
                              </a>
                            )}
                            className="forecast-result__info-row-value"
                          />
                        </div>
                        <div className="forecast-result__info-row">
                          <H3Text text="Data Range" className="forecast-result__info-row-label" />
                          <H3Text text={`${dayjs(selectedForecast?.input_date_from).format('DD MMM YYYY')} - ${dayjs(selectedForecast?.input_date_to).format('DD MMM YYYY')}`} className="forecast-result__info-row-value" />
                        </div>
                        <div className="forecast-result__info-row">
                          <H3Text text="Data Duration" className="forecast-result__info-row-label" />
                          <H3Text text={`${dayjs(selectedForecast?.input_date_to).diff(selectedForecast?.input_date_from, 'week', false)} Weeks`} className="forecast-result__info-row-value" />
                        </div>
                        <div className="forecast-result__info-row">
                          <H3Text text="Forecast Duration" className="forecast-result__info-row-label" />
                          <H3Text text={`${(selectedForecast?.forecast_duration_in_days / 7).toFixed(0)} Weeks`} className="forecast-result__info-row-value" />
                        </div>
                        <div className="forecast-result__info-row">
                          <H3Text text="Date" className="forecast-result__info-row-label" />
                          <H3Text text={dayjs(selectedForecast?.created_at).format('DD/MM/YYYY hh:mm A')} className="forecast-result__info-row-value" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Panel>
            </Collapse>
          </div>
          <div className="document-e-way-info">
            <Collapse
              bordered={false}
              defaultActiveKey={salesKey ? [salesKey] : []}
              onChange={(key) => {
                setSalesKey(key);
              }}
            >
              <Panel
                header={(
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <FontAwesomeIcon icon={faChartArea} />
                    <span style={{ marginLeft: '5px' }}>View Historical Sales Analysis</span>
                    <FontAwesomeIcon icon={salesKey == '1' ? faAngleDown : faAngleRight} style={{ marginTop: '1px', marginLeft: '5px', transition: '0.2s' }} />
                  </div>
                )}
                key="1"
              >
                <ForecastAnalysis />
              </Panel>
            </Collapse>
          </div>
          <div className="ant-row">
            <div className="ant-col-md-16">
              <div className="forecast-result__chart">
                <ReactApexChart options={optionsLine} series={seriesLine} type="area" height={330} />
              </div>
            </div>
            <div className="ant-col-md-8">
              <div className="forecast-result__inputs" style={{ height: '100%' }}>
                <div className="forecast-result__input-wrapper">
                  <label className="forecast-result__label">
                    Model
                    <span style={{ color: 'red' }}>*</span>
                  </label>
                  <PRZSelect
                    value={selectedModel}
                    onChange={(val) => {
                      setSelectedModel(val);
                      setActiveChange(true);
                    }}
                    showSearch={false}
                    className="forecast-result__model-select"
                  >
                    <Option value="xgboost">
                      {`XGBoost (${Number((100 - selectedForecast?.model_percentage_errors?.xgb_model)?.toFixed(2))}%)`}
                      &nbsp;
                      {getBestModel()?.key === 'xgb_model' && (
                        <Recommended />
                      )}
                    </Option>
                    <Option value="ridge">
                      {`Ridge ( ${Number((100 - selectedForecast?.model_percentage_errors?.ridge_model)?.toFixed(2))}%)`}
                      &nbsp;
                      {getBestModel()?.key === 'ridge_model' && (
                        <Recommended />
                      )}
                    </Option>
                    <Option value="lasso">
                      {`Lasso ( ${Number((100 - selectedForecast?.model_percentage_errors?.lasso_model)?.toFixed(2))}%)`}
                      &nbsp;
                      {getBestModel()?.key === 'lasso_model' && (
                        <Recommended />
                      )}
                    </Option>
                    <Option value="linear_regression">
                      {`Liner Regression ( ${Number((100 - selectedForecast?.model_percentage_errors?.lr_model)?.toFixed(2))}%)`}
                      &nbsp;
                      {getBestModel()?.key === 'lr_model' && (
                        <Recommended />
                      )}
                    </Option>
                  </PRZSelect>
                </div>
                <div className="forecast-result__input-wrapper">
                  <label className="forecast-result__label">
                    Location
                    <span style={{ color: 'red' }}>*</span>
                  </label>
                  <PRZSelect
                    value={selectedStore}
                    onChange={(val) => {
                      setActiveChange(true);
                      setSelectedStore(val);
                    }}
                    placeholder="Filter by location.."
                    showSearch={false}
                    mode="multiple"
                    maxTagCount="responsive"
                  >
                    {forecastResults?.unique_stores?.map((item) => (
                      <Option value={item} key={item} />
                    ))}
                  </PRZSelect>
                </div>
                <div className="forecast-result__input-wrapper">
                  <label className="forecast-result__label">
                    Products
                    <span style={{ color: 'red' }}>*</span>
                  </label>
                  <PRZSelect
                    value={selectedProduct}
                    onChange={(val) => {
                      setActiveChange(true);
                      setSelectedProduct(val);
                    }}
                    showSearch={false}
                    mode="multiple"
                    maxTagCount="responsive"
                    placeholder="Filter by product.."
                  >
                    {forecastResults?.unique_items?.map((item) => (
                      <Option value={item} key={item} />
                    ))}
                  </PRZSelect>
                </div>
                {/* <div className="forecast-result__input-wrapper"> */}
                {/*  <label className="forecast-result__label"> */}
                {/*    Sales Channel */}
                {/*    <span style={{ color: 'red' }}>*</span> */}
                {/*  </label> */}
                {/*  <Select */}
                {/*    value={selectedChannel} */}
                {/*    onChange={(val) => { */}
                {/*      setActiveChange(true); */}
                {/*      setSelectedChannel(val); */}
                {/*    }} */}
                {/*    showSearch={false} */}
                {/*    mode="multiple" */}
                {/*    maxTagCount="responsive" */}
                {/*    disabled */}
                {/*  /> */}
                {/* </div> */}
                <div className="forecast-result__input-wrapper">
                  <label className="forecast-result__label">
                    Exploded View
                  </label>
                  <PRZSelect
                    value={groupBy}
                    onChange={(val) => {
                      setGroupBy(val);
                      setActiveChange(true);
                    }}
                    showSearch={false}
                  >
                    <Option value="STORE">Location</Option>
                    <Option value="ITEM">Product</Option>
                  </PRZSelect>
                </div>
                <div style={{ marginTop: '20px' }}>
                  <Button
                    onClick={() => {
                      getForecastResults({
                        forecastId: selectedForecast?.forecast_id,
                        // forecastId: 55,
                        modelName: selectedModel,
                        store: selectedStore?.join(','),
                        item: selectedProduct?.join(','),
                      });
                      setActiveChange(false);
                      setSelectedGroup(groupBy);
                    }}
                    type="primary"
                    disabled={!activeChange || getForecastResultsLoading || downloadForecastLoading}
                  >
                    Apply Filters
                  </Button>
                  &nbsp;
                  &nbsp;
                  <Button
                    onClick={() => {
                      downloadForecast({
                        forecastId: selectedForecast?.forecast_id,
                        // forecastId: 55,
                        modelName: selectedModel,
                        store: selectedStore?.join(','),
                        item: selectedProduct?.join(','),
                      });
                    }}
                    type="primary"
                    disabled={downloadForecastLoading}
                    loading={downloadForecastLoading}
                  >
                    <DownloadOutlined />
                    &nbsp;
                    Download
                  </Button>
                </div>
              </div>
            </div>
            <div className="ant-col-md-24">
              <div className="forecast-result__data-explode">
                <Table
                  showHeader
                  loading={getForecastResultsLoading}
                  scroll={{ x: 'max-content', y: '100dvh' }}
                  columns={getExplodedViewColumns()}
                  dataSource={getExplodedViewData() || []}
                  pagination={false}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

const mapStateToProps = ({
  UserReducers, ForecastReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  createForecastLoading: ForecastReducers.createForecastLoading,
  getForecastByIdLoading: ForecastReducers.getForecastByIdLoading,
  selectedForecast: ForecastReducers.selectedForecast,
  startForecastLoading: ForecastReducers.startForecastLoading,
  getForecastResultsLoading: ForecastReducers.getForecastResultsLoading,
  forecastResults: ForecastReducers.forecastResults,
  downloadForecastLoading: ForecastReducers.downloadForecastLoading,
});

const mapDispatchToProps = (dispatch) => ({
  createForecast: (formData, callback) => dispatch(ForecastActions.createForecast(formData, callback)),
  startForecast: (payload, callback) => dispatch(ForecastActions.startForecast(payload, callback)),
  getForecastResults: (payload, callback) => dispatch(ForecastActions.getForecastResults(payload, callback)),
  getForecastById: (payload, callback) => dispatch(ForecastActions.getForecastById(payload, callback)),
  getForecastByIdSuccess: (selectedForecast) => dispatch(ForecastActions.getForecastByIdSuccess(selectedForecast)),
  downloadForecast: (payload, callback) => dispatch(ForecastActions.downloadForecast(payload, callback)),
});

ForecastResults.propTypes = {
  user: PropTypes.any,
  createForecast: PropTypes.func,
  createForecastLoading: PropTypes.bool,
  getForecastById: PropTypes.func,
  getForecastByIdLoading: PropTypes.bool,
  startForecastLoading: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ForecastResults));
